import { Check, X } from "lucide-react";

const ROWS = [
  { label: "Upfront deposit", trad: "May apply", ppa: "$0" },
  { label: "Annual rate change", trad: "8–12% annually", ppa: "3% annual escalator" },
  { label: "Equity", trad: "None", ppa: "Day One" },
  { label: "Monthly amount", trad: "Varies with usage & season", ppa: "Predictable annual energy rate" },
  { label: "Term", trad: "FOREVER", ppa: "25-year term" },
];

export default function PPAComparison() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="ppa-comparison-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">Side by Side</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            Traditional utility-style cost vs the Fixed PPA option.
          </h2>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-6">
          <div className="card-warm p-8" data-testid="ppa-traditional-card">
            <div className="eyebrow text-slate-500" style={{ color: "#64748B" }}>Traditional</div>
            <h3 className="mt-2 font-serif-display text-2xl text-slate-700">Utility-Style Cost</h3>
            <ul className="mt-6 space-y-3">
              {ROWS.map((r) => (
                <li key={r.label} className="flex items-start gap-3 text-sm text-slate-600">
                  <X className="w-4 h-4 mt-0.5 text-slate-400 shrink-0" />
                  <div><span className="font-medium text-slate-700">{r.label}:</span> {r.trad}</div>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-[1.25rem] p-8 relative overflow-hidden text-[#F8FAFC]" style={{ background: "linear-gradient(155deg, #0F382C 0%, #164E3D 100%)" }} data-testid="ppa-fixed-card">
            <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full opacity-20" style={{ background: "#D97706" }} />
            <div className="relative">
              <div className="eyebrow" style={{ color: "#FEF3C7" }}>Fixed PPA</div>
              <h3 className="mt-2 font-serif-display text-2xl">ION Virginia PPA</h3>
              <ul className="mt-6 space-y-3">
                {ROWS.map((r) => (
                  <li key={r.label} className="flex items-start gap-3 text-sm">
                    <Check className="w-4 h-4 mt-0.5 text-[#FEF3C7] shrink-0" />
                    <div><span className="font-medium">{r.label}:</span> <span className="text-[#F8FAFC]/85">{r.ppa}</span></div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
